module.exports = __webpack_public_path__ + "static/media/delete.ba4dcaa3.svg";